module.exports = __webpack_public_path__ + "img/2.a466426e.jpg";